import {
  CatalogIcon,
  DocsIcon,
  GroupIcon,
  Link,
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
  SidebarSubmenu,
  SidebarSubmenuItem,
  useSidebarOpenState,
} from '@backstage/core-components';
import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { CatalogSearchResultListItem } from '@backstage/plugin-catalog';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { TechDocsSearchResultListItem } from '@backstage/plugin-techdocs';
import { Settings as SidebarSettings } from '@backstage/plugin-user-settings';
import { AdrSearchResultListItem } from '@backstage-community/plugin-adr';
import {
  ConfluenceSearchResultListItem,
  ConfluenceSearchIcon,
} from '@backstage-community/plugin-confluence';
import { makeStyles } from '@material-ui/core';
import CategoryIcon from '@material-ui/icons/Category';
import ExtensionIcon from '@material-ui/icons/Extension';
import HomeIcon from '@material-ui/icons/Home';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import ComponentIcon from '@material-ui/icons/Memory';
import UserIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import ResourceIcon from '@material-ui/icons/Work';
import CardTravel from '@material-ui/icons/CardTravel';
import GavelIcon from '@material-ui/icons/Gavel';
import LogoFull from '../../components/Root/LogoFull';
import LogoIcon from '../../components/Root/LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const sidebarContent: ExtensionDefinition = NavContentBlueprint.make({
  params: {
    component: () => {
      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal
              resultItemComponents={
                <>
                  <CatalogSearchResultListItem icon={<CatalogIcon />} />
                  <TechDocsSearchResultListItem icon={<DocsIcon />} />
                  <AdrSearchResultListItem icon={<GavelIcon />} />
                  <ConfluenceSearchResultListItem
                    icon={<ConfluenceSearchIcon />}
                  />
                </>
              }
            />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarItem icon={HomeIcon} to="/" text="Home" />
          <MyGroupsSidebarItem
            singularTitle="My Team"
            pluralTitle="My Groups"
            icon={GroupIcon}
          />
          <SidebarItem icon={CategoryIcon} to="/catalog" text="Catalog">
            <SidebarSubmenu title="Catalog">
              <SidebarSubmenuItem
                title="Components"
                to="/catalog?filters[kind]=component"
                icon={ComponentIcon}
              />
              <SidebarSubmenuItem
                title="Resources"
                to="/catalog?filters[kind]=resource"
                icon={ResourceIcon}
              />
              <SidebarDivider />
              <SidebarSubmenuItem
                title="Groups"
                to="/catalog?filters[kind]=group"
                icon={GroupIcon}
              />
              <SidebarSubmenuItem
                title="Users"
                to="/catalog?filters[kind]=user"
                icon={UserIcon}
              />
            </SidebarSubmenu>
          </SidebarItem>
          <SidebarItem icon={ExtensionIcon} to="/api-docs" text="APIs" />
          <SidebarItem icon={LibraryBooks} to="/docs" text="Docs" />
          <SidebarItem icon={CardTravel} to="/toolbox" text="Toolbox" />
          <SidebarDivider />
          <SidebarSpace />
          <SidebarDivider />
          <SidebarSettings />
        </Sidebar>
      );
    },
  },
});
